
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 md:pt-0">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/cab7f752f15f9fbe09fc4e4bf6e6fe35.jpg" 
          alt="Premium Carthaginian Treasure Olive Oil"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 text-center px-5 md:px-6 max-w-5xl mx-auto w-full py-8 md:py-0">
        <div className="mb-4 md:mb-6 inline-block">
          <span className="text-amber-300 text-xs md:text-sm font-medium tracking-widest uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            From Ancient Groves to Your Table
          </span>
        </div>
        
        <h1 className="text-3xl sm:text-4xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Carthaginian Treasure
        </h1>
        
        <p className="text-base sm:text-lg md:text-2xl text-white mb-3 md:mb-4 font-light leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          A Unique, Single-Sourced, Cold-Pressed Extra Virgin Olive Oil
        </p>
        
        <p className="text-sm md:text-lg text-gray-100 mb-8 md:mb-10 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          Harvested from ancient wild olive trees in the mountainous regions of Tunisia, bringing you <strong>6 generations</strong> of <strong>Mediterranean tradition</strong>, rich in <strong>antioxidants</strong> and <strong>polyphenols</strong>
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
          <button 
            onClick={() => scrollToSection('cta')}
            className="bg-amber-500 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-amber-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg w-full sm:w-auto"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Experience the Treasure
          </button>
          <button 
            onClick={() => scrollToSection('story')}
            className="bg-white/20 backdrop-blur-sm text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-white/30 transition-all border border-white/40 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Discover Our Story
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
}
